import { Validators } from "@angular/forms"
import { GridOption, NoiseFractileOption, NoiseOption, sharedForms } from "../layer.model"
import { Form, FormType, NoiseProperties, Properties, SharedProperties } from "../properties.model"
import { EffectsType } from "../ui-effects.model"
import FastNoiseLite from "fastnoise-lite-typed"

const noiseTypes: NoiseOption[] = [
  { label: 'Perlin', value: FastNoiseLite.NoiseType.Perlin },
  { label: 'Cellular', value: FastNoiseLite.NoiseType.Cellular },
  { label: 'Open Simplex 2', value: FastNoiseLite.NoiseType.OpenSimplex2 },
  { label: 'Open Simplex 2s', value: FastNoiseLite.NoiseType.OpenSimplex2S },
  { label: 'Value', value: FastNoiseLite.NoiseType.Value },
  { label: 'Value Cubic ', value: FastNoiseLite.NoiseType.ValueCubic },
]

const fractileTypes: NoiseFractileOption[] = [
  { label: 'FBm', value: FastNoiseLite.FractalType.FBm },
  { label: 'Ridged', value: FastNoiseLite.FractalType.Ridged },
  { label: 'Ping Pong', value: FastNoiseLite.FractalType.PingPong },
  { label: 'None', value: FastNoiseLite.FractalType.None },
]

const sharedBlenderingFormControl = sharedForms.find(form => form.id === SharedProperties.BlendingMode)
if (!sharedBlenderingFormControl) {
  throw new Error('Blending mode form not found')
}

const blendingFormControl: Form = {
  ...sharedBlenderingFormControl,
  id: NoiseProperties.NoiseBlendingMode
}

export const noiseForm: Properties = {
  propertyType: EffectsType.Noise,
  label: 'Noise',
  forms:[
    blendingFormControl,
    {
      id: NoiseProperties.NoiseType,
      label: 'Noise Type',
      type: FormType.Select,
      defaultValue: [{viewValue: "Perlin", value: FastNoiseLite.NoiseType.Perlin}],
      validators: [Validators.required, Validators.minLength(1)],
      options: noiseTypes
    },
    {
      id: NoiseProperties.NoiseOpacity,
      label: 'Opacity',
      type: FormType.SliderNumber,
      defaultValue: .01,
      validators: [Validators.required],
      sliderOptions: {
        min: 0.01,
        max: 1,
        step: 0.01
      },
    },
    {
      id: NoiseProperties.NoiseFrequency,
      label: 'Frequency',
      type: FormType.SliderNumber,
      defaultValue: 0,
      validators: [Validators.required],
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      },
    },
    {
      id: NoiseProperties.NoiseSeed,
      label: 'Seed',
      type: FormType.SliderNumber,
      defaultValue: .01,
      validators: [Validators.required],
      sliderOptions: {
        min: 0.01,
        max: 1,
        step: 0.01
      },
    },
    {
      id: NoiseProperties.NoiseColorGradient,
      label: 'Color Gradient',
      type: FormType.Gradient,
      defaultValue: '#FFFFFF',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: NoiseProperties.NoiseInvertMask,
      label: 'Invert Layer Mask',
      type: FormType.Checkbox,
      defaultValue: false
    },
    {
      id: NoiseProperties.NoiseHideUnderlyingLayer,
      label: 'Hide Underlying Layer',
      type: FormType.Checkbox,
      defaultValue: false
    },
    {
      id: NoiseProperties.NoiseFractileType,
      label: 'Factile Type',
      type: FormType.Select,
      defaultValue: [{viewValue: "None", value: FastNoiseLite.FractalType.None}],
      validators: [Validators.required, Validators.minLength(1)],
      options: fractileTypes
    },
    {
      id: NoiseProperties.NoiseFractileOctives,
      label: 'Fractile Octives',
      type: FormType.InputNumber,
      allowDecimal: true,
      defaultValue: 0,
      validators: [Validators.required],
    },
    {
      id: NoiseProperties.NoiseFractileGain,
      label: 'Fractile Gain',
      type: FormType.InputNumber,
      allowDecimal: true,
      defaultValue: 0,
      validators: [Validators.required],
    },
    {
      id: NoiseProperties.NoiseFractileLacunarity,
      label: 'Fractile Lacunarity',
      allowDecimal: true,
      type: FormType.InputNumber,
      defaultValue: 0,
      validators: [Validators.required],
    },
  ],
  changeHandler: () => {}
}

